import React, { useState, useEffect } from 'react';
import { DatePicker, Input, Image as AntdImage, Tooltip, Tag, Button, Timeline, Space, Typography, Empty } from 'antd';
import { CaretDownOutlined, SearchOutlined, LinkOutlined, PlusCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useSelector, useDispatch } from "react-redux";

import Iconfont from "../../../../components/Iconfont/Iconfont";
import KnowledgeFileIconV7 from "../../../../components/KnowledgeFileIconV7/index";
import SelfPagination from "../../../../components/SelfPagination/index";
import dateIcon from "../../../../assets/img/V7/dateIcon.svg";
import policyIcon from "../../../../assets/img/V7/policyIcon.svg";
import Ministry from "./ministry";
import Local from "./local";
import Api from "../../../../api";
import { setQAKowledgeList } from "../../../../features/AIIntelligentV7/AIReducer";
import { viewAttachment } from "../../../../utils/tool";
import "./index.scss";

const { RangePicker } = DatePicker;
const { Text, Title, } = Typography;
const PolicyList = ({
    listDate,
    pagination,
    knowledgeTypeId,
    paginationChange,
    searchChange,
    searchData
}) => {
    const dispatch = useDispatch();
    const QAKowledgeList = useSelector(state => state.AIReducerV7.QAKowledgeList);

    const policyTypeList = [
        {text: "全部", value: {id: "1", type: "", policyRegionId: ""}},
        {text: "国务院", value: {id: "2", type: "0", policyRegionId: ""}},
        {text: "部委", value: {id: "3", type: "1", policyRegionId: ""}},
        {text: "地方", value: {id: "4", type: "2", policyRegionId: "2"}},
    ];
    const [policyType, setPolicyType] = useState(policyTypeList[0].value.id);
    const [searchValue, setSearchValue] = useState('');
    const [openRangePicker, setOpenRangePicker] = useState(false);

    const [countryDeptList, setCountryDeptList] = useState([])
    const [regionList, setRegionList] = useState([])

    const [newListDate, setNewListDate] = useState([])

    useEffect(()=>{
        setNewListDate(listDate)
    },[JSON.stringify(listDate)])


    // useEffect(()=>{
    //     setCountryDeptList([]);
    //     setRegionList([]);
    //     searchChange({
    //         // "type": item.value.type,
    //         // "policyRegionId": item.value.policyRegionId,
    //         'countryDeptIds':[],
    //         'codes': []
    //     });
    // },[policyType])

    const handleChange = (e) => {
        if(!e.target.value){
            searchChange({
                "knowledgeName":""
            });
        }
        setSearchValue(e.target.value);
    };

    const handleSearch = () => {
        searchChange({
            "knowledgeName":searchValue
        });
    };

    const changeRangePicker = (dates, dateStrings) =>{
        console.log(dates, dateStrings);
        searchChange({
            "endTime":dateStrings[0],
            "startTime":dateStrings[1]
        });
    }

    const ministryChange = (values) => {
        console.log(values,values.countryDeptList,"values");
        setCountryDeptList(values.countryDeptList || []);
        setRegionList(values.codesList || []);
        delete values.codesList;
        delete values.countryDeptList;
        searchChange(values);
    }

    const setPolicyTypeF = (item) => {

        if(policyType != item.value.id){
            setCountryDeptList([]);
            setRegionList([]);
            searchChange({
                "type": item.value.type,
                "policyRegionId": item.value.policyRegionId,
                'countryDeptIds':[],
                'codes': []
            });
        }else{
            searchChange({
                "type": item.value.type,
                "policyRegionId": item.value.policyRegionId,
            });
        }

        setPolicyType(item.value.id);
        
    }

    const delectSelected = (value) => {
        if(value === 'all'){
            searchChange({
                countryDeptIds:[],
                codes:[]
            })
            setCountryDeptList([])
            setRegionList([]);
        }else{
            let id = value.id || value.code;
            searchChange({
                countryDeptIds: [...searchData.countryDeptIds.filter(item => item !== id)],
                codes: [...searchData.codes.filter(item => item !== id)]
            })

            let data = countryDeptList.filter(item => {
                if(item.id){
                    return item.id !== id;
                }else if(item.code){
                    return item.code !== id;
                }
            })

            let regionData = regionList.filter(item => {
                if(item.id){
                    return item.id !== id;
                }else if(item.code){
                    return item.code !== id;
                }
            })

            setCountryDeptList(data);
            setRegionList(regionData);
        }
    }

    const getFooterOperation = (item) => {
        let content = "";
        
        content = (
            <div className="oprationBox" style={{textAlign: 'right'}}>
                <Space>
                    {item.titleHref?<Tooltip placement="topLeft" title="原文地址">
                        <LinkOutlined onClick={(e)=>{
                            e.stopPropagation();
                            window.open(item.titleHref);
                        }}/>
                    </Tooltip>:null}
                </Space>
            </div>
        )

        return content
    }

    const getLabel = (item) => {
        return (<div className="policyLabel">
            <Text className="policyLabelTime">{item.time}</Text><br/>
            <Text type="secondary">{item.source}</Text>
        </div>)
    }
    
     const addAIQA = (item) => { 
        dispatch(setQAKowledgeList([
            ...QAKowledgeList,
            item
        ]))

        console.log([
                ...QAKowledgeList,
                item
            ]);
    }

    const moreAttachmentList = (items) => {
        let key = items.id;
        let _newListDate = [...newListDate]
        _newListDate.map(item=>{
            let id = item.id;
            if(id === key){
                item.moreOpen = !item.moreOpen
            }
        })
        setNewListDate(_newListDate)
    }

    const goPolicyDetails = (item) => {
        // 政策爬虫文件没有文件类型，默认给pdf
        window.open(`/page/knowledgeDetails?knowledgeId=${item.id}&type=policy&knowledgeFileType=${item.fileType}&permission=true`)
    }

    return(
        <>
            <div className="policyListTitle">政策列表</div>
            <div className="policyTypeList">
                {policyTypeList.map((item, index) => {
                    console.log(item.value, item.value.id)
                    if(item.value.id === '3'){ 
                        return <Ministry
                            id={item.value.id}
                            key={item.value.id}
                            ministryHtml={
                                <div 
                                className={`policyTypeItem ${policyType === item.value.id ? 'active' : ''}`}
                                onClick={()=>setPolicyTypeF(item)}
                                >{item.text} <CaretDownOutlined /></div>
                            }
                            callBack={ministryChange}
                            searchData={searchData}
                            policyTypeId={policyType}
                            countryDeptList={countryDeptList}
                        />
                    }else if(item.value.id === '4'){ 
                         return <Local
                            key={item.value.id}
                            ministryHtml={
                                <div 
                                className={`policyTypeItem ${policyType === item.value.id ? 'active' : ''}`}
                                onClick={()=>setPolicyTypeF(item)}
                                >{item.text} <CaretDownOutlined /></div>
                            }
                            callBack={ministryChange}
                            searchData={searchData}
                            policyTypeId={policyType}
                            countryDeptList={countryDeptList}
                            regionList={regionList}
                        />
                    }
                    else{
                        return <div 
                            key={item.value.id}
                            className={`policyTypeItem ${policyType === item.value.id ? 'active' : ''}`}
                            onClick={()=>setPolicyTypeF(item)}
                            >{item.text}</div>
                    }
                })}
            </div>

            <div className="policyListParm">
                <div className="paramListParamLeft">
                    {((countryDeptList && countryDeptList.length > 0) || (regionList && regionList.length > 0)) && <>
                        已选：{countryDeptList.map(item=>{
                            return <Tag 
                            key={item.id || item.code}
                            className="paramItem" 
                            color="#F2F3FF" 
                            closable 
                            onClose={() => delectSelected(item)}
                            >{item.name}</Tag>
                        })}
                        {regionList.map(item=>{
                            return <Tag 
                            key={item.id || item.code}
                            className="paramItem" 
                            color="#F2F3FF" 
                            closable 
                            onClose={() => delectSelected(item)}
                            >{item.name}</Tag>
                        })}
                        <Button type="primary" size="small" onClick={() => delectSelected('all')}>重置</Button>
                    </>}
                </div>
                <div className="paramListParamRight">
                    <div style={{display:'inline-block'}} className={`${openRangePicker ? 'rangePickerinput' : ''}`}>
                        {openRangePicker&&<RangePicker 
                            value={searchData.startTime?[moment(searchData.startTime), moment(searchData.endTime)]:[]}
                            ranges={{
                                '今天': [moment(), moment()],
                                '本周': [moment().startOf('week'), moment().endOf('week')],
                                '本月': [moment().startOf('month'), moment().endOf('month')],
                            }}
                            onChange={changeRangePicker}
                            suffixIcon={null}
                            bordered={false}
                        />}
                        
                        <AntdImage
                            preview={false}
                            src={dateIcon}
                            onClick={()=>setOpenRangePicker(!openRangePicker)}
                        />
                    </div>
                    <Input
                        placeholder={'请输入内容'}
                        prefix={<SearchOutlined />}
                        style={{width: '190px',marginBottom: '0.5rem'}}
                        allowClear={true}
                        onChange={handleChange}
                        value={searchValue}
                        onPressEnter={handleSearch}
                    />
                </div>
                
            </div>
            <div className="policyKnowledgeList">
                {newListDate && newListDate.length > 0 ? 
                <Timeline mode={'left'}>
                    {newListDate.map(item => (
                        <Timeline.Item
                            key={item.id} 
                            label={getLabel(item)}
                        >
                            <div className="icon">
                                {/* 文件图标 */}
                                <AntdImage
                                    preview={false}
                                    src={policyIcon}
                                />
                            </div>
                            <div className="policyContent">
                                <div className="iconAndTitle">
                                    <div
                                        className="contentItemTitle"
                                        title={item.title}
                                        dangerouslySetInnerHTML={{__html: item.title}}
                                        onClick={()=>goPolicyDetails({
                                            ...item,
                                            type:"policy",
                                            knowledgeTypeId:"4",
                                        })}
                                    />
                                    {/* AI */}
                                    <Tooltip 
                                        title="加入解析栏"
                                    >
                                        <div className="addQA" onClick={(e)=>{
                                            e.stopPropagation();
                                            addAIQA(item)
                                        }}><PlusCircleOutlined /></div>
                                    </Tooltip>

                                    {getFooterOperation(item)}
                                </div>

                                {/* 标签 */}
                                {item.lables&&item.lables.length>0&&<div className="tagList">
                                    {item.lables.map(items=><div className="tagItem">{items}</div>)}
                                </div>}

                                {/* 是否是手动摘要(1是，2否) */}
                                {item.isManual === 1?(
                                    <div
                                        className="contentText"
                                        title={item.content}
                                        dangerouslySetInnerHTML={{__html: item.content}}
                                    />
                                ):(
                                    <div
                                        className="contentText"
                                        title={item.content}
                                        dangerouslySetInnerHTML={{__html: item.content}}
                                    />
                                )}

                                {item.policyAttachs && item.policyAttachs.length > 0 && (
                                    <>
                                        <div className="attachmentList" style={
                                            item.moreOpen ? {height: 'auto'} :
                                            item.policyAttachs.length === 1 ? {height: '35px'} : {height: '70px'}
                                            }>
                                            {item.policyAttachs.map((items, index) => {
                                                return <div key={index} className="attachmentListItem"
                                                    onClick={()=>viewAttachment(items)}
                                                >
                                                    <div className="fileIconclassName">
                                                        <KnowledgeFileIconV7 fileType={items.fileType} />
                                                        附件{index+1}：
                                                    </div>
                                                    <div className="attachmentName" dangerouslySetInnerHTML={{__html: items.attachmentName}}></div>
                                                </div>
                                            })}
                                        </div>
                                        {item.policyAttachs.length > 2 &&
                                        <div className="moreAttachmentList" onClick={(e)=>{
                                            e.stopPropagation();
                                            moreAttachmentList(item)
                                        }}>
                                            {item.moreOpen ? <><Iconfont type={'icon-shangjiantou4'}/>收起</> :<><Iconfont type={'icon-xiala'}/>更多</>}
                                            
                                        </div>}
                                    </>
                                )}
                                
                                
                            </div>
                        </Timeline.Item>
                    ))}
                </Timeline>: <Empty />}
                {pagination && (pagination.total> 0)?(<div className="pagination">
                    <SelfPagination
                        current={pagination.pageIndex}
                        total={pagination.total}
                        onSizeChange={paginationChange}
                    />
                </div>):""}

            </div>
        </>
    )
}

export default PolicyList;
